<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.template_list.email_templates') }}
      </h1>
    </div>
    <v-data-table
      fixed-header
      :headers="headers"
      :items="templates"
      :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100] }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading || preloading"
      :loading-text="$t('common.loading_data')"
    >
      <template v-slot:item.event.saveDb="{ item }">
        {{ item.event.saveDb ? $t('common.yes') : $t('common.no') }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-hover
          v-if="editor"
          v-slot="{ hover }"
        >
          <v-icon
            class="mr-4"
            :class="hover ? '' : 'text--disabled'"
            color="primary"
            size="20"
            @click="showSettingsModal(item)"
          >
            mdi-cog-outline
          </v-icon>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <v-icon
            :class="hover ? '' : 'text--disabled'"
            color="primary"
            size="20"
            @click="$router.push(`/emails/templates/${item.name}`)"
          >
            mdi-open-in-new
          </v-icon>
        </v-hover>
      </template>
    </v-data-table>
    <event-settings
      v-model="isSettingsModalShown"
      :selected-event="selectedEvent"
      @submit="getEvents"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventSettings from '@/components/emails/EventSettings';

export default {
  name: 'TemplateList',

  components: {
    EventSettings,
  },

  data() {
    return {
      items: [],
      total: 0,
      options: {},

      headers: [
        {
          text: this.$t('common.name'),
          value: 'name',
        },
        {
          text: this.$t('views.template_list.subject'),
          value: 'subject',
        },
        {
          text: this.$t('views.template_list.save_db'),
          value: 'event.saveDb',
        },
        {
          text: this.$t('common.actions'),
          value: 'actions',
          sortable: false,
          width: 150,
          align: 'center',
        },
      ],

      preloading: false,
      loading: false,
      isSettingsModalShown: false,

      events: [],
      selectedEvent: {},
    };
  },

  computed: {
    ...mapGetters(['editor']),

    templates() {
      return this.items.map((item) => {
        let event = this.events.find((e) => e.name === item.name);
        if (!event) {
          event = {
            name: item.name, saveDb: true, type: 'system', options: [],
          };
        }
        return { ...item, event };
      });
    },
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  created() {
    this.getEvents();
  },

  methods: {
    async getEvents() {
      this.preloading = true;
      try {
        const { data } = await this.$http.get('/events', { pageSize: 0 });
        this.events = data.rows;
      } finally {
        this.preloading = false;
      }
    },

    async getItems() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = {};
      params.pageSize = itemsPerPage;
      params.page = page;
      if (sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      this.loading = true;

      try {
        const { data } = await this.$http.get('templates', { params });
        this.items = data.rows;
        this.total = data.total;
      } finally {
        this.loading = false;
      }
    },

    showSettingsModal(template) {
      this.isSettingsModalShown = true;
      this.selectedEvent = template.event;
    },
  },
};
</script>
